import LaunchIcon from '@mui/icons-material/Launch'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

import { formatDate } from '@util/date-util'

import type { Projectdossier } from '../../projectdossier/types/Projectdossier'
import { StyledIconLink } from '../../theme/components/StyledIconLink'

interface Props {
  projectdossier: Projectdossier
}

export const ProjectdossiersTableRow = ({ projectdossier }: Props) => {
  const {
    _id,
    projectdossierId,
    naam,
    externeReferentie,
    gebiedscodeLabel,
    statusText,
    indiener,
    aanlegger,
  } = projectdossier

  return (
    <TableRow key={_id}>
      <TableCell>{projectdossierId}</TableCell>
      <TableCell>{naam}</TableCell>
      <TableCell>{externeReferentie}</TableCell>
      <TableCell>{gebiedscodeLabel}</TableCell>
      <TableCell>{statusText}</TableCell>
      <TableCell>{indiener.naam}</TableCell>
      <TableCell>{indiener.organisatie}</TableCell>
      <TableCell>{formatDate(aanlegger.date)}</TableCell>
      <TableCell>
        <StyledIconLink
          title={`Navigeer naar projectdossier ${projectdossierId}`}
          icon={<LaunchIcon />}
          href={`/projectdossier/${projectdossierId}`}
        />
      </TableCell>
    </TableRow>
  )
}
